/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React, {useContext, useEffect, useRef, useState} from 'react';
import {
  EditContainer,
  EditSectionLeft,
  FilterSection,
  EditFooter,
  EditWrapper,
  EditSectionRight,
  EditFooterRightBtns,
  EditFooterLeftBtns,
  TeamBasicInfo,
  FormField,
  AddLogoButton,
  AddLogoButtonText,
  AddLogoButtonWrapper,
  BadgeWrapper,
  FilterCounter,
  FilterCounterTiTle,
  FilterSelectedCounter,
  FilterSelectedPills,
  DeleteModal,
  Content,
  Arrow,
  Point,
  Curve,
} from './styles';
import {PowerDropdown, InputComponent, TableTeamPlayer, LargeButton, Label, Badge, BadgeImage, Tabs, Modal, Media, Loader} from '..';
import {useInputValue} from '../../utils/hooks/useInputValue';
import {ARMcontext} from '../../utils/context/context';
import {Teams, Utils} from '../../utils/api/';
import {AddLogo} from '../../assets/icons/icons';
import { queryClient } from '../../utils/helpers/queryClient';
import { GetPropertyByPath } from '../../utils/helpers/path';
import { useLocation } from 'react-router-dom';

const DefaultPlayers = [
  {title: 'Players', lenght: 50},
  {title: 'Pitchers', lenght: 20},
  {title: 'Catchers', lenght: 30},
];

const DefaultPills = [
  {
    title: 'All',
    numBadge: 0,
    active: true,
  },
  {
    title: 'Pitchers',
    numBadge: 0,
    active: false,
  },
  {
    title: 'Catchers',
    numBadge: 0,
    active: false,
  },
  {
    title: 'Infielders',
    numBadge: 0,
    active: false,
  },
  {
    title: 'Outfielders',
    numBadge: 0,
    active: false,
  },
];

const DefaultCities = [{name: 'Denver'}, {name: 'New york'}, {name: 'Kansas'}];
const DefaultStates = [{name: 'CO'}, {name: 'KA'}, {name: 'WS'}];
const DefaultPallette = [
  {badge: 'NULL', color: 'rgba(253,185,18,1)', title: ''},
  {badge: 'NULL', color: 'rgba(253,139,18,1)', title: ''},
  {badge: 'NULL', color: 'rgba(207,153,95,1)', title: ''},
  {badge: 'NULL', color: 'rgba(150,60,21,1)', title: ''},
  {badge: 'NULL', color: 'rgba(80,180,128,1)', title: ''},
  {badge: 'NULL', color: 'rgba(132,192,193,1)', title: ''},
  {badge: 'NULL', color: 'rgba(62,174,242,1)', title: ''},
  {badge: 'NULL', color: 'rgba(32,121,194,1)', title: ''},
  {badge: 'NULL', color: 'rgba(71,55,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(102,124,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(156,85,239,1)', title: ''},
  {badge: 'NULL', color: 'rgba(126,73,184,1)', title: ''},
  {badge: 'NULL', color: 'rgba(240,120,255,1)', title: ''},
  {badge: 'NULL', color: 'rgba(248,73,88,0.9)', title: ''},
  {badge: 'NULL', color: 'rgba(255,94,85,1)', title: ''},
  {badge: 'NULL', color: 'rgba(97,99,102,1)', title: ''},
  {badge: 'NULL', color: 'rgba(26,57,92,1)', title: ''},
];

export default ({HandleEditTeam}: {HandleEditTeam: (value?: boolean) => void, RecallMyTeams: () => Promise<void>}) => {
  const teamLogoRef = useRef<HTMLInputElement | any>(document.createElement('input'));
  const [defaultPlayers, useDefaultPlayers] = useState<Array<any>>(DefaultPlayers);
  const [defaultCities, useDefaultCities] = useState<any>(DefaultCities);
  const [defaultStates, useDefaultStates] = useState<any>(DefaultStates);
  const [tableData, useTableData] = useState<Array<any>>([]);
  const [players, usePlayers] = useState<any>(DefaultPlayers[0]);
  const [pills, usePills] = useState<Array<any>>(DefaultPills);
  const {teamMemo, selectedTeam, HandleToastMessage, HandleSelectedTeam, setTriggerRefresh, triggerRefresh} = useContext(ARMcontext);
  const [states, useStates] = useState<any>({name: selectedTeam.state});
  const [selectedCheck, useSelectedCheck] = useState<boolean>(false);
  const [normalCheck, useNormalCheck] = useState<boolean>(false);
  const [city, useCity] = useState<any>({name: selectedTeam.city});
  const [submit, useSubmit] = useState<boolean>(false);
  const [team, useTeam] = useState<any>(teamMemo[0]);
  const [alert, useAlert] = useState<boolean>(false);
  const [pallette, usePallette] = useState<any>({badge: 'NULL', color: selectedTeam.color, title: ''});
  const [selected, useSelected] = useState<any>([]);
  const [counter, useCounter] = useState<number>(0);
  const [selectedCounter, useSelectedCounter] = useState<number>(0);
  const [namePills, useNamePills] = useState<string>('');
  const [loadingSelected, useLoadingSelected] = useState<boolean>(true);
  const [loadingAvailable, useLoadingAvailable] = useState<boolean>(true);
  const SearchInput = useInputValue('', 'search');
  const [image, useImage] = useState<any>('');
  const TeamBadge = useInputValue(selectedTeam?.initials || selectedTeam.badge);
  const NameInput = useInputValue(selectedTeam.name);
  const location = useLocation();
  const TEAMS = new Teams();
  const UTILS = new Utils();

  useEffect(() => {
    useCounter(tableData.reduce((total, el) => (el?.checked ? total + 1 : total), 0));
    useSelectedCounter(selected.reduce((total, el) => (el?.selected ? total + 1 : total), 0));
  }, [tableData, selected]);

  useEffect(() => {
    BuildPlayersFilter();
    BuildStates();
    GetPlayersOfTheSelectedTeam(selectedTeam);
  }, []);
  useEffect(() => {
    TeamBadge.HandleValue(TeamBadge.value.toUpperCase());
  }, [TeamBadge.value]);

  async function GetPlayersOfTheOrganization(sTeam: any, provisionalMemory = selected) {
    useLoadingAvailable(true);
    const playerTeams = await TEAMS.GetPlayersOfAteam(true, 1, sTeam._id);
    console.log('EditTeam - GetPlayersOfTheOrganization (data cruda del backend):', playerTeams);
    if (playerTeams.status) {
      await CheckDuplicatePlayers([...playerTeams.data['player-teams']], provisionalMemory);
    }
    useLoadingAvailable(false);
  }

  async function GetPlayersOfTheSelectedTeam(sTeam: any) {
    useLoadingSelected(true);
    const playerTeams = await TEAMS.GetPlayersOfAteam(true, 1, sTeam._id);
    console.log('EditTeam - GetPlayersOfTheSelectedTeam (data cruda del backend):', playerTeams);
    if (playerTeams.status) {
      updatePills([...playerTeams.data['player-teams']]);
      useSelected([...playerTeams.data['player-teams']]);
      useLoadingSelected(false);
      await CheckDuplicatePlayers(tableData, [...playerTeams.data['player-teams']]);
      await GetPlayersOfTheOrganization(teamMemo[0], [...playerTeams.data['player-teams']]);
    } else {
      useLoadingSelected(false);
      useLoadingAvailable(false);
    }
  }

  function ChangeTeam(selectedTeam: any) {
    useTeam(selectedTeam);
    BuildPlayersFilter(selectedTeam);
    GetPlayersOfTheOrganization(selectedTeam);
  }

  async function BuildStates() {
    const result = await TEAMS.GetStates();
    if (result.status) {
      useDefaultStates(result.data);
      GetCities(result.data[0]._id);
    }
  }

  async function GetCities(cityId: string) {
    const cities = await TEAMS.GetCities(cityId);
    if (cities.status) {
      useDefaultCities(cities.data);
    }
  }

  function ChangePlayers(selectedOption: any) {
    usePlayers(selectedOption);
  }

  function ChangePallette(selectedOption: any) {
    usePallette(selectedOption);
  }

  function ChangeCity(selectedOption: any) {
    useCity(selectedOption);
  }

  function ChangeStates(selectedOption: any) {
    useStates(selectedOption);
    GetCities(selectedOption._id);
  }

  function ChangeImage(selectedOption: any) {
    useImage(selectedOption);
  }

  function DeleteTeamLogo() {
    ChangeImage('');
  }

  function updatePills(uTeam) {
    const pitcher = uTeam.reduce((total, el) => (el.player.primaryPosition === 'pitcher' ? total + 1 : total), 0);
    const catcher = uTeam.reduce((total, el) => (el.player.primaryPosition === 'catcher' ? total + 1 : total), 0);
    const infielder = uTeam.reduce((total, el) => (el.player.primaryPosition === 'infielder' ? total + 1 : total), 0);
    const outfielder = uTeam.reduce((total, el) => (el.player.primaryPosition === 'outfielder' ? total + 1 : total), 0);
    usePills(prev => {
      const muted = prev;
      muted[0].numBadge = uTeam.length;
      muted[1].numBadge = pitcher;
      muted[2].numBadge = catcher;
      muted[3].numBadge = infielder;
      muted[4].numBadge = outfielder;
      return muted;
    });
  }

  function handleUploadTeamLogo() {
    teamLogoRef.current.click();
    teamLogoRef.current.onchange = () => ChangeImage(teamLogoRef.current.files[0]);
  }

  function BuildPlayersFilter(activeTeam = teamMemo[0]) {
    const players = [
      {
        title: 'Players',
        lenght: activeTeam?.players?.length.toString() || activeTeam?.totalPlayers.toString(),
        value: '',
      },
      {
        title: 'Pitchers',
        lenght: activeTeam.pitchers.toString(),
        value: 'Pitchers',
      },
      {
        title: 'Catchers',
        lenght: activeTeam.catchers.toString(),
        value: 'Catchers',
      },
      {
        title: 'Infielders',
        lenght: activeTeam.infielders.toString(),
        value: 'Infielders',
      },
      {
        title: 'Outfielders',
        lenght: activeTeam.outfielders.toString(),
        value: 'Outfielders',
      },
    ];
    usePlayers(players[0]);
    useDefaultPlayers(players);
  }

  function HandleAllPlayers(check: any) {
    useNormalCheck(check);
    const drop: string = players?.title || '';
    if (drop === 'Players') {
      useTableData([
        ...tableData.map(el => {
          el['checked'] = check;
          return el;
        }),
      ]);
    } else {
      useTableData([
        ...tableData.filter(el => {
          return !drop.toLowerCase()?.includes(el.player?.primaryPosition);
        }),
        ...tableData
          .filter(el => {
            return drop.toLowerCase()?.includes(el.player?.primaryPosition);
          })
          .map(el => {
            el['checked'] = check;
            return el;
          }),
      ]);
    }
  }

  function HandleOnePlayer(check: any) {
    useTableData([
      ...tableData.map(el => {
        if (check.player.email === el.player.email) {
          el['checked'] = !el?.checked || false;
        }
        return el;
      }),
    ]);
  }

  function HandleAllSelectedPlayers(check: any) {
    useSelectedCheck(check);
    const pill: string = pills?.filter(el => el.active === true)[0].title || '';
    if (pill === 'All') {
      useSelected([
        ...selected.map(el => {
          el['selected'] = check;
          return el;
        }),
      ]);
    } else {
      useSelected([
        ...selected.filter(el => {
          if (pills) {
            return !pill.toLowerCase()?.includes(el.player?.primaryPosition);
          } else {
            return el;
          }
        }),
        ...selected
          .filter(el => {
            if (pills) {
              if (pill === 'All' && pill) {
                return el;
              } else {
                return pill.toLowerCase()?.includes(el.player?.primaryPosition);
              }
            } else {
              return el;
            }
          })
          .map(el => {
            el['selected'] = check;
            return el;
          }),
      ]);
    }
  }

  function HandleOneSelectedPlayer(check: any) {
    useSelected([
      ...selected.map(el => {
        if (check.player.email === el.player.email) {
          el['selected'] = !el?.selected || false;
        }
        return el;
      }),
    ]);
  }

  function HandleAdding() {
    useNormalCheck(false);
    useSelectedCheck(false);
    const result = UTILS.CheckDuplicatesInArray([...selected, ...tableData.filter(el => el.checked)]);
    useSelected([...result]);
    updatePills([...result]);
    CheckDuplicatePlayers(tableData, [...result]);
  }

  function HandleRemovePlayers() {
    useNormalCheck(false);
    useSelectedCheck(false);
    useSelected([...selected.filter(el => !el.selected)]);
    CheckDuplicatePlayers(tableData, [...selected.filter(el => !el.selected)]);
    GetPlayersOfTheOrganization(team, [...selected.filter(el => !el.selected)]);
    updatePills([...selected.filter(el => !el.selected)]);
  }

  async function handleDeleteTeam() {
    useAlert(true);
  }

  async function handleDeleteAlert() {
    const res = await TEAMS.deleteTeam(selectedTeam._id);
    if (res.status) {
      HandleEditTeam(false);
      HandleToastMessage('Team deleted', true, 2000, 'success');
      HandleSelectedTeam(teamMemo[0]);
      queryClient.clear();
    } else {
      HandleToastMessage('An error ocurred deleting the team', true, 2000, 'error');
    }
  }

  async function handleSaveTeam() {
    let error = 0;
    useSubmit(true);

    if (!Boolean(NameInput.value.length)) {
      NameInput.HandleWarning('This field cannot be empty');
      NameInput.HandleStatus('error');
      error++;
    }

    if (!Boolean(TeamBadge.value.length)) {
      TeamBadge.HandleWarning('This field cannot be empty');
      TeamBadge.HandleStatus('error');
      error++;
    }

    if (!error) {
      let converted = '';
      const updatePlayers = selected.map(el => el.player._id);
      if (image) {
        const resultImage = await UTILS.UploadFile(image);
        converted = resultImage.data.path;
      } else if (selectedTeam?.picture) {
        converted = selectedTeam?.picture || '';
      }

      const res = await TEAMS.updateTeam(
        NameInput.value,
        pallette.color,
        TeamBadge.value,
        selectedTeam._id,
        city.name,
        states.name,
        updatePlayers,
        converted,
      );
      useSubmit(false);
      const property = GetPropertyByPath(location.pathname);
      if (res.status) {
        setTriggerRefresh({
          ...triggerRefresh,
          [property]: true,
        });
        queryClient.clear();
        HandleSelectedTeam({
          ...selectedTeam,
          ...{
            name: NameInput.value,
            color: pallette.color,
            initials: TeamBadge.value,
            city: city.name,
            state: states.name,
            picture: converted,
          },
        });
        HandleEditTeam(false);
        HandleToastMessage('Team updated', true, 2000, 'success');
      } else {
        HandleToastMessage('An error ocurred updating the team', true, 2000, 'error');
      }
    }
  }

  function handlePills(element) {
    useNamePills(element);
    usePills(
      pills.map(el => {
        if (el.title === element) {
          el.active = true;
        } else {
          el.active = false;
        }
        return el;
      }),
    );
  }

  function CheckDuplicatePlayers(tableD, selectedD): Promise<any> {
    return new Promise(resolve => {
      const final = tableD.filter(el => {
        const res = selectedD.filter(il => el.player.id.includes(il.player.id))[0];
        if (res?._id) {
          return false;
        } else {
          return true;
        }
      });
      useTableData([...final]);
      return resolve({status: true, final});
    });
  }

  return (
    <>
      <EditContainer>
        <EditWrapper>
          <EditSectionLeft>
            {!counter ? (
              <FilterSection>
                <PowerDropdown
                  primaryTitle={team.name}
                  badge={team?.initials || team.badge}
                  colorBadge={team.color}
                  picture={team.picture}
                  search={true}
                  onClick={ChangeTeam}
                  dataArray={teamMemo}
                  mPadding="4px 0 4px 10px"
                  mWidth="200"
                />
                <PowerDropdown
                  primaryTitle={players.title}
                  visibleLenght={players.lenght}
                  search={false}
                  onClick={ChangePlayers}
                  dataArray={defaultPlayers}
                  mPadding="4px 0 4px 10px"
                />
                <InputComponent dynamicSearch={SearchInput} />
              </FilterSection>
            ) : (
              <FilterCounter>
                <FilterCounterTiTle>Add Players</FilterCounterTiTle>
              </FilterCounter>
            )}
            {loadingAvailable ? (
              <Loader height="200px" />
            ) : (
              <TableTeamPlayer
                titleHeader="PLAYERS"
                dropFilter={players}
                selectedCheck={normalCheck}
                dataTableContent={tableData}
                filterInput={SearchInput.value}
                HandleOnePlayer={HandleOnePlayer}
                HandleAllPlayers={HandleAllPlayers}
                namePills={namePills}
              />
            )}
          </EditSectionLeft>
          <EditSectionRight>
            {selectedCounter ? (
              <FilterSelectedCounter>
                <LargeButton
                  callback={HandleRemovePlayers}
                  rColor="#FF3B30"
                  lColor="#E1342A"
                  icon="arrowLeft"
                  title={`REMOVE (${selectedCounter}) PLAYERS`}
                />
                <FilterCounterTiTle>Remove from team</FilterCounterTiTle>
              </FilterSelectedCounter>
            ) : (
              <TeamBasicInfo>
                <FormField style={{position: 'relative', marginRight: '13px'}}>
                  <BadgeWrapper>
                    {!image ? (
                      <>
                        {selectedTeam.picture ? (
                          <Media imgUrl={selectedTeam.picture} size="80px" mRight="0" />
                        ) : (
                          <Badge
                            text={TeamBadge.value}
                            size="82px"
                            font="30px"
                            family="Proxima Nova"
                            color={pallette.color}
                            weight="500"
                          />
                        )}
                        <AddLogoButtonWrapper>
                          <input ref={teamLogoRef} type="file" accept="image/png, image/jpeg" style={{display: 'none'}} />
                          <AddLogoButton onClick={handleUploadTeamLogo}>
                            <AddLogo />
                            <AddLogoButtonText>ADD LOGO</AddLogoButtonText>
                          </AddLogoButton>
                        </AddLogoButtonWrapper>
                      </>
                    ) : (
                      <BadgeImage srcImage={URL.createObjectURL(image)} callback={DeleteTeamLogo} size="82px" />
                    )}
                  </BadgeWrapper>
                </FormField>
                <FormField style={{width: '200px', marginRight: '7px'}}>
                  <Label text="Team Name" />
                  <InputComponent placeholder="Team Name" dynamicSearch={NameInput} maxLength={50} />
                </FormField>
                <FormField style={{width: '65px', marginRight: '7px'}}>
                  <Label text="Initial" />
                  <InputComponent placeholder="C8" dynamicSearch={TeamBadge} maxLength={2} />
                </FormField>
                <FormField style={{width: '70px', marginRight: '7px'}}>
                  <Label text="Color" />

                  <PowerDropdown
                    dataArray={DefaultPallette}
                    mHeigth={'200px'}
                    badge={pallette.badge}
                    colorBadge={pallette.color}
                    onClick={ChangePallette}
                    search={false}
                    mWidth="90%"
                    mPadding="4px 0 4px 10px"
                  />
                </FormField>
                <FormField style={{marginRight: '7px'}}>
                  <Label text="City" />
                  <PowerDropdown
                    dataArray={defaultCities}
                    primaryTitle={city.name}
                    onClick={ChangeCity}
                    search={false}
                    mWidth="100%"
                    mPadding="4px 0 4px 10px"
                  />
                </FormField>
                <FormField>
                  <Label text="State" />
                  <PowerDropdown
                    dataArray={defaultStates}
                    primaryTitle={states.name}
                    onClick={ChangeStates}
                    search={false}
                    mWidth="100%"
                    mPadding="4px 0 4px 10px"
                  />
                </FormField>
              </TeamBasicInfo>
            )}

            <FilterSelectedPills>
              <Tabs dataArray={pills} wBadge={true} onClick={handlePills} />
            </FilterSelectedPills>

            <div style={{margin: '15px 10px'}}>
              {loadingSelected ? (
                <Loader height="200px" />
              ) : selected.length ? (
                <TableTeamPlayer
                  check2={true}
                  pillFilter={pills}
                  dataTableContent={selected}
                  selectedCheck={selectedCheck}
                  titleHeader="ARM CARE PLAYERS"
                  filterInput={SearchInput.value}
                  HandleOnePlayer={HandleOneSelectedPlayer}
                  HandleAllPlayers={HandleAllSelectedPlayers}
                  namePills={namePills}
                />
              ) : (
                <div style={{position: 'relative', left: '7%', top: '30px'}}>
                  <Content>
                    <Arrow>
                      <Curve></Curve>
                      <Point></Point>
                    </Arrow>
                  </Content>
                  <Content>
                    <h1>Select the players you want to be part of this team</h1>
                  </Content>
                </div>
              )}
            </div>
          </EditSectionRight>
        </EditWrapper>
        <EditFooter>
          <EditFooterLeftBtns>
            <LargeButton
              callback={handleDeleteTeam}
              rColor="#ffffff"
              lColor="#ffffff"
              title="DELETE TEAM"
              fColor="#F54B23"
              bColor="#F54B23"
              lMargin="0 0 0 20px"
              icon="trash"
              xMargin="0 10px 0 0"
            />
            {counter > 0 && (
              <LargeButton
                callback={HandleAdding}
                rColor="#006BE1"
                lColor="#007AFF"
                rIcon="arrowRight"
                fColor="#fff"
                lMargin="0px 30px"
                rMargin="0px 10px"
                title={`ADD (${counter}) PLAYERS`}
              />
            )}
          </EditFooterLeftBtns>
          <EditFooterRightBtns>
            <LargeButton
              callback={() => HandleEditTeam(false)}
              rColor="#ffffff"
              lColor="#ffffff"
              title="CANCEL"
              fColor="#5D6C76"
              bColor="#F0F0F0"
              lMargin="0"
              xMargin="0 10px 0 0"
            />
            {submit ? (
              <Loader width="180px" />
            ) : (
              <LargeButton callback={handleSaveTeam} rColor="#FF3B30" lColor="#E1342A" icon="done" title="SAVE TEAM" />
            )}
          </EditFooterRightBtns>
        </EditFooter>
      </EditContainer>
      {alert && (
        <Modal title="Delete" subtitle="Do you want to permanently delete this team?" margin="28vh auto 200px auto">
          <DeleteModal>
            <EditFooterRightBtns>
              <LargeButton
                callback={() => useAlert(false)}
                rColor="#ffffff"
                lColor="#ffffff"
                title="CANCEL"
                fColor="#5D6C76"
                bColor="#F0F0F0"
                lMargin="0"
                xMargin="0 10px 0 0"
              />
              <LargeButton callback={handleDeleteAlert} rColor="#FF3B30" lColor="#E1342A" icon="trash" title="DELETE TEAM" />
            </EditFooterRightBtns>
          </DeleteModal>
        </Modal>
      )}
    </>
  );
};
